/**
 * fuse-recommendations.js
 *
 * Custom element que trae las recomendaciones reales de Shopify
 * (routes.product_recommendations_url) y las inserta dentro del
 * carrusel Fuse una vez que llegan, disparando el evento
 * "fuse:recommendations-ready" para que el script del carrusel
 * inicialice Swiper con los productos ya cargados.
 *
 * Debe subirse a Assets del tema como "fuse-recommendations.js".
 */

class FuseProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;

    // Sin producto de referencia válido: no hay nada que buscar,
    // el Liquid ya muestra el estado de onboarding.
    if (!url) return;

    const sectionId = this.dataset.sectionId;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Fuse product recommendations: respuesta no válida (' + response.status + ')'
          );
        }
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContent = doc.getElementById('fuse-recommendations-content-' + sectionId);
        const currentContent = this.querySelector('#fuse-recommendations-content-' + sectionId);

        if (!newContent || !currentContent) {
          this.dataset.hasRecommendations = 'false';
          return;
        }

        const hasRealProducts =
          newContent.querySelectorAll('[data-real-product="true"]').length > 0;

        currentContent.innerHTML = newContent.innerHTML;
        this.dataset.hasRecommendations = hasRealProducts ? 'true' : 'false';

        this.dispatchEvent(
          new CustomEvent('fuse:recommendations-ready', { bubbles: true })
        );
      })
      .catch((error) => {
        this.dataset.hasRecommendations = 'false';
        console.error('Fuse product recommendations:', error);
      });
  }
}

if (!customElements.get('fuse-product-recommendations')) {
  customElements.define('fuse-product-recommendations', FuseProductRecommendations);
}